import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from 'seagull';
import { getAccountingDetails } from '~/integrations/Accounting/accounting.utils';
import { Accounting } from '~/types/api.model';
export function getAccountingTooltip(accountingIntegration) {
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": "accounting-tooltip",
        children: /*#__PURE__*/ _jsxs(Typography, {
            skin: "invertedStandard",
            variant: "paragraph1",
            children: [
                "This line item is mapped to",
                ' ',
                /*#__PURE__*/ _jsxs(Typography, {
                    variant: "paragraph1",
                    weight: "bold",
                    as: "span",
                    testId: "qbo-item-name",
                    skin: "invertedStandard",
                    children: [
                        accountingIntegration.itemName,
                        ' '
                    ]
                }),
                accountingIntegration.accounting === Accounting.QBO && accountingIntegration.className && /*#__PURE__*/ _jsxs(Typography, {
                    variant: "paragraph1",
                    as: "span",
                    skin: "invertedStandard",
                    children: [
                        "with the Class",
                        ' ',
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "paragraph1",
                            weight: "bold",
                            as: "span",
                            testId: "qbo-class-name",
                            skin: "invertedStandard",
                            children: accountingIntegration.className
                        })
                    ]
                }),
                ' ',
                "in ",
                getAccountingDetails(accountingIntegration.accounting).fullName
            ]
        })
    });
}
